import React, { useState } from 'react';
import {
  itemSelectedStyle,
  quizOptionsListStyle,
  quizOptionStyle
} from './QuizScreenStyles';
import { useAppStore } from '../../hooks/useAppStore';

const QuizOptions: React.FC<any> = ({ question }) => {
  const { gamificationState = {}, setGamificationState } = useAppStore();
  const { selectedAnswerId } = gamificationState;

  const quizSelectedItemHandler = (e: React.SyntheticEvent, id: string) => {
    e.preventDefault();
    setGamificationState({ selectedAnswerId: id });
  };

  // const quizSubmitHandler = (e: React.SyntheticEvent) => {
  //   e.preventDefault();
  //   // const response = postSelectedAnswer(id);
  //   const updatedQuestions = questions.map((item) => {
  //     if (item.id === question.id) {
  //       return {
  //         ...item,
  //         userAnswerResponse: {
  //           questionId: question?.id,
  //           userSelectedOptionId: id,
  //           correctAnswerId: null,
  //           isAnswerCorrect: null
  //         }
  //       };
  //     }
  //     return item;
  //   });

  //   setGamificationState({ questions: updatedQuestions });
  // };

  const renderQuizOptions = () => {
    return question?.options.map((option: any) => {
      return (
        <li
          key={option?.id}
          css={[
            quizOptionStyle,
            selectedAnswerId === option?.id && itemSelectedStyle
          ]}
          onClick={(e) => quizSelectedItemHandler(e, option?.id)}>
          {option?.optionText}
        </li>
      );
    });
  };

  return <ul css={quizOptionsListStyle}>{renderQuizOptions()}</ul>;
};

export default QuizOptions;
